/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Visibility_Enabled_TitleInputs */

const en_cas_visibility_enabled_title = /** @type {(inputs: Cas_Visibility_Enabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAS Visibility has changed`)
};

/**
* | output |
* | --- |
* | "CAS Visibility has changed" |
*
* @param {Cas_Visibility_Enabled_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_visibility_enabled_title = /** @type {((inputs?: Cas_Visibility_Enabled_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Visibility_Enabled_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_visibility_enabled_title(inputs)
});